// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ReviewDocumentSummaryTrowser_DocumentFragment = { __typename?: 'Document', id: string, name: string, file: { __typename?: 'File', id: string, pages?: Array<{ __typename?: 'FilePage', id: string, pageNumber: number, width?: number | null, height?: number | null, unit?: string | null }> | null }, pdfFile?: { __typename?: 'File', id: string, pages?: Array<{ __typename?: 'FilePage', id: string, pageNumber: number, width?: number | null, height?: number | null, unit?: string | null }> | null } | null, summaries?: Array<{ __typename?: 'DocumentSummary', id: string, displayName: string, summary: string, aiSummaryRating?: Types.DocumentSummaryAiSummaryRating | null, aiSummaryFeedback?: string | null, entryMode?: Types.DocumentSummaryEntryMode | null, summaryFormat?: Types.DocumentSummarySummaryFormat | null, createdBy: string, createdAt: Time, updatedAt: Time, sourceDocuments: { __typename?: 'DocumentConnection', edges?: Array<{ __typename?: 'DocumentEdge', node?: { __typename?: 'Document', id: string, name: string } | null } | null> | null }, updateUser: { __typename?: 'User', id: string, displayName: string } }> | null };

export type ReviewDocumentSummaryTrowserQueryVariables = Types.Exact<{
  documentIds: Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input'];
}>;


export type ReviewDocumentSummaryTrowserQuery = { __typename?: 'Query', documents: { __typename?: 'DocumentConnection', edges?: Array<{ __typename?: 'DocumentEdge', node?: (
        { __typename?: 'Document' }
        & ReviewDocumentSummaryTrowser_DocumentFragment
      ) | null } | null> | null } };

export const Operations = {
  Query: {
    ReviewDocumentSummaryTrowser: 'ReviewDocumentSummaryTrowser' as const
  },
  Fragment: {
    ReviewDocumentSummaryTrowser_Document: 'ReviewDocumentSummaryTrowser_Document' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const ReviewDocumentSummaryTrowser_DocumentFragmentDoc = gql`
    fragment ReviewDocumentSummaryTrowser_Document on Document {
  id
  name
  file {
    id
    pages {
      id
      pageNumber
      width
      height
      unit
    }
  }
  pdfFile {
    id
    pages {
      id
      pageNumber
      width
      height
      unit
    }
  }
  summaries {
    id
    displayName
    summary
    aiSummaryRating
    aiSummaryFeedback
    entryMode
    summaryFormat
    createdBy
    createdAt
    updatedAt
    sourceDocuments(first: 100) {
      edges {
        node {
          id
          name
        }
      }
    }
    updateUser {
      id
      displayName
    }
  }
}
    `;
export const ReviewDocumentSummaryTrowserDocument = gql`
    query ReviewDocumentSummaryTrowser($documentIds: [ID!]!) {
  documents(where: {idIn: $documentIds}) {
    edges {
      node {
        ...ReviewDocumentSummaryTrowser_Document
      }
    }
  }
}
    ${ReviewDocumentSummaryTrowser_DocumentFragmentDoc}`;

/**
 * __useReviewDocumentSummaryTrowserQuery__
 *
 * To run a query within a React component, call `useReviewDocumentSummaryTrowserQuery` and pass it any options that fit your needs.
 * When your component renders, `useReviewDocumentSummaryTrowserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReviewDocumentSummaryTrowserQuery({
 *   variables: {
 *      documentIds: // value for 'documentIds'
 *   },
 * });
 */
export function useReviewDocumentSummaryTrowserQuery(baseOptions: Apollo.QueryHookOptions<ReviewDocumentSummaryTrowserQuery, ReviewDocumentSummaryTrowserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReviewDocumentSummaryTrowserQuery, ReviewDocumentSummaryTrowserQueryVariables>(ReviewDocumentSummaryTrowserDocument, withFetchPolicyContext(options));
      }
export function useReviewDocumentSummaryTrowserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReviewDocumentSummaryTrowserQuery, ReviewDocumentSummaryTrowserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReviewDocumentSummaryTrowserQuery, ReviewDocumentSummaryTrowserQueryVariables>(ReviewDocumentSummaryTrowserDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useReviewDocumentSummaryTrowserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ReviewDocumentSummaryTrowserQuery, ReviewDocumentSummaryTrowserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReviewDocumentSummaryTrowserQuery, ReviewDocumentSummaryTrowserQueryVariables>(ReviewDocumentSummaryTrowserDocument, withFetchPolicyContext(options));
        }
export type ReviewDocumentSummaryTrowserQueryHookResult = ReturnType<typeof useReviewDocumentSummaryTrowserQuery>;
export type ReviewDocumentSummaryTrowserLazyQueryHookResult = ReturnType<typeof useReviewDocumentSummaryTrowserLazyQuery>;
export type ReviewDocumentSummaryTrowserSuspenseQueryHookResult = ReturnType<typeof useReviewDocumentSummaryTrowserSuspenseQuery>;
export type ReviewDocumentSummaryTrowserQueryResult = Apollo.QueryResult<ReviewDocumentSummaryTrowserQuery, ReviewDocumentSummaryTrowserQueryVariables>;